import { useQueryMembershipPlan } from '@/features/account/services/MembershipPlan/queries'
import { formatDate } from '@/features/shared/utils/date'
import {
  SubscriptionId,
  MembershipInterval,
  MembershipStatus,
  type PlanName,
} from '@/features/account/services/MembershipPlan/types'
import { toMembershipPlan } from '@/features/account/services/MembershipPlan/utils'
import { useQuerySubscriptionPlans } from '@/features/account/services/SubscriptionAux/queries'
import { getMembershipType } from '@/features/account/components/Membership/getMembershipType'

export const useMembership = () => {
  const { data: subscriptionResponse, isFetched: hasMembershipFetched } = useQueryMembershipPlan()
  const membership = toMembershipPlan(subscriptionResponse)
  const { data: upgradePlans } = useQuerySubscriptionPlans({
    planType: 'upgrade',
  })

  const {
    cancelAtPeriodEnd,
    renewalDate,
    intervalCount,
    status,
    trialEnd,
    type,
    id,
    price,
    interval,
  } = membership

  const trialEndDateObj = new Date(trialEnd)

  const planType = getMembershipType(interval, intervalCount)

  const endDate = formatDate(new Date(renewalDate), 'MMM d, yyyy')
  const trialEndDate = formatDate(trialEndDateObj, 'MMM d, yyyy')
  const isRenewing = !cancelAtPeriodEnd

  const isTrial = status === MembershipStatus.trialing
  const isActive = status === MembershipStatus.active
  const isStudent = membership.id === SubscriptionId.STUDENT_MONTHLY
  const isSnapEBT = membership.id === SubscriptionId.SNAP_EBT_MONTHLY
  const planName: PlanName = isStudent ? 'Student' : isSnapEBT ? 'SNAP EBT' : planType

  const canUpgrade =
    interval !== MembershipInterval.year &&
    intervalCount === 1 &&
    isRenewing &&
    !isTrial &&
    !isStudent &&
    !isSnapEBT &&
    Boolean(upgradePlans?.some((plan) => plan.plan_type === 'upgrade'))

  return {
    // membership properties
    type, // only used to calculate C360
    id,
    renewalDate,
    cancelAtPeriodEnd, // only used on Profile page
    interval,
    price,
    // end membership properties
    hasMembershipFetched,
    planType,
    planName,
    isTrial,
    isActive,
    isStudent,
    isSnapEBT,
    endDate,
    trialEndDate, // only used on membership dashboard
    isRenewing,
    canUpgrade,
    upgradePlans,
  }
}
